const NotificationBar = ()=>{
    return (
        <div
              className="flex items-center justify-between p-4 mb-8 text-sm font-semibold text-white bg-blue-600 rounded-lg shadow-md focus:outline-none focus:shadow-outline-green"
               
            >
              <div className="flex items-center">
               
                <span>..</span>
              </div>
              <span> --Ledger--</span>
            </div>
    );
}

export default NotificationBar;